(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    static observedAttributes = ['aria-hidden'];

    constructor() {
      super();
      this.storageKey = this.dataset.storageKey || 'announcement-closed';
      this.ariaHidden = window.sessionStorage.getItem(this.storageKey) !== null;
    }

    connectedCallback() {
      this.querySelectorAll('[data-close]').forEach((closeElement) => {
        closeElement.addEventListener('click', () => {
          const cssRoot = document.querySelector(':root');
          cssRoot.style.setProperty('--announcement-bar-height', '0px');
          closeElement.blur(); // For accessibility
          this.ariaHidden = true;

          const customEvent = new CustomEvent('announcementClosed', {
            detail: { message: 'Announcement bar closed' },
          });

          // Dispatch the custom event
          closeElement.dispatchEvent(customEvent);
        });
      });
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'aria-hidden') {
        try {
          if (newValue === 'true') {
            window.sessionStorage.setItem(this.storageKey, true);
          } else {
            window.sessionStorage.removeItem(this.storageKey);
          }
        } catch (error) {
          window.console.warn(error);
        }
      }
    }
  }
  window.customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-strip"]) return;
  try {
    
  class PromoStripSection extends HTMLElement {
    constructor() {
      super();
      this.currentSlide = 0;
      this.intervalId = null;
      this.headerElem = null;
      this.stickyOffsetFrame = null;
      this.handleResize = this.handleResize.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
      this.handleAnnouncementClosed = this.handleAnnouncementClosed.bind(this);
    }

    connectedCallback() {
      this.layout = this.dataset.layout;
      this.timerLength = Number(this.dataset.timerLength || 9) * 1000;
      this.stickyEnabled = this.dataset.sticky === 'true';
      this.headerElem = document.querySelector('[data-header]') || document.querySelector('header');
      this.desktopMediaQuery = window.matchMedia('(min-width: 750px)');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.previousControl = this.querySelector('[data-direction="previous"]');
      this.nextControl = this.querySelector('[data-direction="next"]');

      if (this.previousControl) {
        this.previousControl.addEventListener('click', () => this.goToPreviousSlide());
      }

      if (this.nextControl) {
        this.nextControl.addEventListener('click', () => this.goToNextSlide());
      }

      this.refresh();

      window.addEventListener('resize', this.handleResize);
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('announcementClosed', this.handleAnnouncementClosed, true);
    }

    disconnectedCallback() {
      this.stopTimer();
      if (this.stickyOffsetFrame) {
        window.cancelAnimationFrame(this.stickyOffsetFrame);
        this.stickyOffsetFrame = null;
      }
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('announcementClosed', this.handleAnnouncementClosed, true);
    }

    get isDesktop() {
      return this.desktopMediaQuery.matches;
    }

    get visibleSlides() {
      return this.slides.filter((slide) => {
        const devices = slide.dataset.devices || 'all';
        if (devices === 'all') return true;
        if (devices === 'desktop') return this.isDesktop;
        if (devices === 'mobile') return !this.isDesktop;
        return true;
      });
    }

    handleResize() {
      this.refresh();
    }

    handleScroll() {
      if (!this.stickyEnabled) return;
      this.scheduleStickyOffsetUpdate();
    }

    handleAnnouncementClosed() {
      if (!this.stickyEnabled) return;
      this.scheduleStickyOffsetUpdate();
    }

    scheduleStickyOffsetUpdate() {
      if (this.stickyOffsetFrame) return;

      this.stickyOffsetFrame = window.requestAnimationFrame(() => {
        this.stickyOffsetFrame = null;
        this.updateStickyOffset();
      });
    }

    refresh() {
      const visibleSlides = this.visibleSlides;

      this.updateSlideVisibility(visibleSlides);
      this.updateStickyOffset();

      if (this.layout === 'inline') {
        this.stopTimer();
        return;
      }

      if (visibleSlides.length === 0) {
        this.stopTimer();
        return;
      }

      if (this.currentSlide >= visibleSlides.length) {
        this.currentSlide = 0;
      }

      this.renderActiveSlide(visibleSlides);

      if (this.layout === 'alternate_timer') {
        this.startTimer(visibleSlides);
      } else {
        this.stopTimer();
      }
    }

    updateSlideVisibility(visibleSlides = this.visibleSlides) {
      this.slides.forEach((slide) => {
        const isVisible = visibleSlides.includes(slide);
        slide.hidden = !isVisible;
        slide.classList.remove('is-active');
      });

      const controlsHidden = visibleSlides.length <= 1;
      if (this.previousControl) this.previousControl.hidden = controlsHidden;
      if (this.nextControl) this.nextControl.hidden = controlsHidden;
    }

    renderActiveSlide(visibleSlides = this.visibleSlides) {
      visibleSlides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === this.currentSlide);
      });
    }

    goToNextSlide() {
      const slides = this.visibleSlides;
      if (slides.length <= 1) return;
      this.currentSlide = (this.currentSlide + 1) % slides.length;
      this.renderActiveSlide();
    }

    goToPreviousSlide() {
      const slides = this.visibleSlides;
      if (slides.length <= 1) return;
      this.currentSlide = (this.currentSlide + slides.length - 1) % slides.length;
      this.renderActiveSlide();
    }

    startTimer(visibleSlides = this.visibleSlides) {
      this.stopTimer();
      if (visibleSlides.length <= 1) return;
      this.intervalId = window.setInterval(() => this.goToNextSlide(), this.timerLength);
    }

    stopTimer() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    updateStickyOffset() {
      if (!this.stickyEnabled) return;
      const headerElem = this.headerElem || document.querySelector('[data-header]') || document.querySelector('header');
      const headerHidden = headerElem ? headerElem.classList.contains('-translate-y-full') : false;
      const offset = headerElem && !headerHidden ? headerElem.offsetHeight : 0;
      this.classList.toggle('promo-strip--hidden', headerHidden);
      this.style.setProperty('--promo-strip-sticky-top', `${offset}px`);
    }
  }

  if (!window.customElements.get('promo-strip-section')) {
    window.customElements.define('promo-strip-section', PromoStripSection);
  }

  } catch(e) { console.error(e); }
})();
})();
